import { render } from "./OngoingDetailsModal.vue?vue&type=template&id=715a7c86&scoped=true"
import script from "./OngoingDetailsModal.vue?vue&type=script&lang=js"
export * from "./OngoingDetailsModal.vue?vue&type=script&lang=js"

import "./OngoingDetailsModal.vue?vue&type=style&index=0&id=715a7c86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715a7c86"]])

export default __exports__